export default __webpack_public_path__ + "static/media/upload_primary.24fb6117.svg";